// client/src/components/pages/AmendmentsAllocateTransactions/findReplace.ts
//
// Find & Replace in Table Edit Mode (ST-00221, audit AMD-45). Matching is case-insensitive on
// the trimmed find text. Replacing touches only the matched text: every occurrence for
// "Contains", the leading / trailing part for "Starts with" / "Ends with", the whole cell for
// "Exact match". (It used to set every matching cell to the replace value in full.)

export type MatchType = 'contains' | 'exact' | 'startsWith' | 'endsWith';

export const cellMatches = (cell: string, find: string, matchType: MatchType): boolean => {
  const value = cell.toLowerCase();
  const search = find.trim().toLowerCase();
  if (!search) return false;
  switch (matchType) {
    case 'exact':
      return value === search;
    case 'startsWith':
      return value.startsWith(search);
    case 'endsWith':
      return value.endsWith(search);
    case 'contains':
    default:
      return value.includes(search);
  }
};

const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** The cell after replacing the matched text (the cell unchanged when it does not match). */
export const replaceInCell = (
  cell: string,
  find: string,
  replace: string,
  matchType: MatchType
): string => {
  const search = find.trim();
  if (!cellMatches(cell, search, matchType)) return cell;
  switch (matchType) {
    case 'exact':
      return replace;
    case 'startsWith':
      return replace + cell.slice(search.length);
    case 'endsWith':
      return cell.slice(0, cell.length - search.length) + replace;
    case 'contains':
    default:
      // A function replacement, so "$&" and friends in the replace text stay literal.
      return cell.replace(new RegExp(escapeRegExp(search), 'gi'), () => replace);
  }
};
